export default __webpack_public_path__ + "static/media/hari_om_singh_core.ec895a55.jpg";